<template>
  <!-- 企业服务-代理记账-开具发票 -->

  <div class="Invoice-body">
    <!-- 筛选 + 发票豆 -->

    <div class="screen-with-bean">
      <el-form
        :model="screenData"
        :inline="true"
        class="screen"
        @submit.native.prevent="handelSearch"
      >
      <el-form-item label="购买方：">
      <div class="size-search">
      <el-input
      v-model="screenData.input"
      placeholder="请输入购买方名称"
      maxlength="30"
      ></el-input>
      </div>
      </el-form-item>
      <el-form-item label="统一社会信用代码(身份证)：" class="user-Id">
      <div class="size-search size-search-wide">
      <el-input
      v-model="screenData.code"
      placeholder="请输入统一社会信用代码(身份证)"
      maxlength="30"
      ></el-input>
      </div>
      </el-form-item>
      <el-form-item label="性质：" class="user-Id">
      <div class="size-search">
      <el-select v-model="screenData.headType" placeholder="请选择性质">
      <el-option
      v-for="item in optionsNature"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      >
      </el-option>
      </el-select>
      </div>
      </el-form-item>
      
      <div class="screen-end">
      <el-form-item label="时间：" >
      <el-date-picker
      v-model="screenData.value"
      type="daterange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      unlink-panels
      clearable
      @clear="screenData.value = null"
      >
      </el-date-picker>
      </el-form-item>
      <el-form-item>
      <el-button
      type="primary"
      class="ser-btn public-style"
      @click="handelSearch"
      >搜 索</el-button
      >
      <el-button class="heavy-btn public-style" @click="handelReset"
      >重 置</el-button
      >
      </el-form-item>
      </div>
    
    </el-form>

      <div class="bean-panel">
        <div class="bean-row">
          <div class="Remaining">
            发票豆：<span class="bean-num">{{ InvoiceBean }}</span>
          </div>
          <el-button
            type="primary"
            class="Buy firm-clickable"
            @click="handelBuyBean"
          >
            购买
          </el-button>
        </div>
        <div class="bean-note">
          <span
            >注：{{ Expired.expireTime }}即将过期{{ Expired.remain }}发票豆</span
          >
          <span class="bean-detail firm-clickable" @click="handelDueDate"
            >详情</span
          >
        </div>
      </div>
    </div>

    <!-- 操作按钮 -->

    <div class="table-top-Controls">
      <div class="RemainingLocation">
        <el-button
          type="primary"
          class="action-btn firm-clickable"
          @click="handelUp"
        >
          代开多家
        </el-button>
        <el-button
          type="primary"
          class="action-btn firm-clickable"
          @click="handelOpen"
        >
          代开一家
        </el-button>
      </div>
    </div>

    <!-- 列表 -->

    <div class="Table">
      <el-table :data="tableData">
        <el-table-column
          prop="orderNumber"
          label="ID"
          width="220"
        >
        </el-table-column>

        <el-table-column prop="customerName" label="购买方" width="200">
        </el-table-column>

        <el-table-column
          prop="customerCreditCode"
          label="统一社会信用代码(身份证)"
          width="220"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column prop="invoiceFormatName" label="开票格式" width="100">
        </el-table-column>

        <el-table-column label="发送方式" show-overflow-tooltip width="100">
          <template slot-scope="scope">
            <span>{{
              scope.row.sendType == 2
                ? "邮箱"
                : scope.row.sendType == 3
                ? "企业微信"
                : ""
            }}</span>
          </template>
        </el-table-column>

        <el-table-column label="性质" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.headType == 0 ? "自然人" : "企业" }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="createTime"
          label="提交时间"
          show-overflow-tooltip
          width="180"
        >
        </el-table-column>

        <el-table-column label="状态" width="100"
          ><template slot-scope="scope">
            <span
              :class="$tool.getProxyStatusClass(scope.row)"
              :style="{ color: getStatusColor(scope.row) }"
              >{{
              scope.row.invalid == 2 ? "作废" : scope.row.statusName
            }}</span>
          </template></el-table-column
        >

        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <span class="span-Operation" @click="handelDetails(scope.row, 0)"
              >详请信息</span
            >

            <span
              class="span-Operation"
              @click="handelDetails(scope.row, 1)"
              v-if="scope.row.refundButton == true"
              >申请退款</span
            >

            <span
              class="span-Operation"
              @click="handelHesitation(scope.row)"
              v-if="scope.row.refundButton == true"
              >立即办理</span
            >

            <span
              class="span-Operation"
              @click="handelEvaluation(scope.row)"
              v-if="scope.row.status == 3"
              >服务评价</span
            >

            <span
              class="span-Operation"
              @click="handelResubmit(scope.$index, scope.row)"
              v-if="scope.row.status == 3 && scope.row.invalid == 0"
              >重新开具发票</span
            >

            <!-- 暂时隐藏投诉
            <span

              class="span-Operation"

              @click="handelComplaint"

              >投诉</span

            >
            -->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 底部分页 -->

    <div class="paging-box">
      <div class="paging">
        <paging
          :pagingObj="pagingObj"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>

    <!-- 购买发票豆 -->

    <BuyBean
      :VisibleBuyBean="VisibleBuyBean"
      @handleCloseBuyBean="VisibleBuyBean = false"
      @handleUnBuyBean="handleUnBuyBean"
      @handleSuccess="handleSuccess"
    ></BuyBean>

    <!-- 上传开具发票弹窗 -->

    <UpInvoice
      :seller="seller"
      :VisibleUp="VisibleUp"
      :options="options"
      @handleCloseUp="VisibleUp = false"
      @handleConfirmUp="handleConfirmUp"
    ></UpInvoice>

    <!-- 代开发票 -->

    <OpenInvoice
      :seller="seller"
      :options="options"
      :dialogIssue="dialogIssue"
      :reissueId="reissueId"
      :reissueRow="reissueRow"
      @handleIssue="handleIssue"
      @handleVerifyIssue="handleVerifyIssue"
    ></OpenInvoice>

    <!-- //详情/申请退款弹窗 -->

    <DeOfRe
      :row="row"
      :seller="seller"
      :VisibleDeRe="VisibleDeRe"
      :DeRe="DeRe"
      @handleCloseDeRe="VisibleDeRe = false"
      @handleConfirmDeRe="handleConfirmDeRe"
    ></DeOfRe>

    <!-- 即将到期发票豆 -->

    <DueDate
      :VisibleDueDate="VisibleDueDate"
      @handleCloseDueDate="VisibleDueDate = false"
    ></DueDate>

    <!-- 立即办理弹窗 -->

    <Hesitation
      :VisibleHesitation="VisibleHesitation"
      @handleCloseHesitation="VisibleHesitation = false"
      @handleUnHesitation="handleUnHesitation"
    ></Hesitation>

    <!-- 服务评价弹窗 -->

    <EvaluationDialog
      :VisibleEvaluation="VisibleEvaluation"
      :orderNumber="orderNumber"
      :handleTypeName="handleTypeName"
      :businessTypeName="businessTypeName"
      :evaluatedName="evaluatedName"
      @handleCloseEvaluation="handleCloseEvaluation"
      @handleSuccess="handleEvaluationSuccess"
    ></EvaluationDialog>

    <!-- 温馨提示弹窗 -->
    <dialogModel
      title="代开发票"
      width="960px"
      :visible.sync="VisibleWarning"
      :footer="false"
      @handleClose="handleWarningClose"
    >
      <div class="warning-content">
        <div class="warning-title">温馨提示：开票信息错误，重开成本高</div>
        <div class="warning-desc">
          您正在使用代开发票功能。请务必仔细核对<span class="em">销售方</span>与<span
            class="em"
            >购买方</span
          >的全部基本信息（名称、税号、开户行等），这些关键字段<span class="em">一旦提交，不可在线修改</span>。如因您个人原因填错信息导致需重新开票，将面临：
        </div>
        <ul class="warning-list">
          <li>
            <span class="em">长周期：</span
            >红冲+重开流程耗时约<span class="em">5个工作日</span
            >，报销或结算将相应延后；
          </li>
          <li>
            <span class="em">不可逆：</span
            >原发票号码作废无法恢复，税务系统中将永久留存作废记录；
          </li>
          <li>
            <span class="em">额外成本：</span
            >跨月重开可能涉及税费损失，且<span class="em">重新代开发票的费用需由您自行承担</span>。
          </li>
        </ul>
      </div>
      <div slot="footer" class="warning-footer">
        <el-button class="dialog-model-btn dialog-model-btn-cancel" @click="handleWarningClose"
          >取消</el-button
        >
        <el-button
          class="dialog-model-btn dialog-model-btn-confirm warning-confirm-btn"
          type="primary"
          @click="handleWarningConfirm"
          >我已知晓</el-button
        >
      </div>
    </dialogModel>
  </div>
</template>



<script>
import * as API from "@/assets/api/Agency/Enterprise.js";

import BuyBean from "./components/InvoiceCom/BuyBean.vue"; // 购买发票豆

import UpInvoice from "./components/InvoiceCom/UpInvoice.vue"; // 上传开具发票弹窗

import OpenInvoice from "./components/InvoiceCom/OpenInvoice.vue"; // 开具发票弹窗

import DeOfRe from "./components/InvoiceCom/NewDetails.vue"; //详情/申请退款弹窗

import DueDate from "./components/InvoiceCom/DueDate.vue"; //即将到期发票豆弹窗

import Hesitation from "./components/IndexCom/Hesitation.vue"; //立即办理弹窗

import EvaluationDialog from "../../components/EvaluationDialog.vue"; //服务评价弹框

// 引入分页组件

import paging from "../../../../../../components/paging.vue";

export default {
  data() {
    return {
      screenData: {
        value: null, // 时间（daterange 清空需为 null，勿用 []）

        input: "", //开票主体

        code: "", //统一社会信用代码

        headType: "", //性质

        orderNumber: "", //订单id
      },

      tableData: [],

      optionsNature: [
        { label: "自然人", value: "0" },

        { label: "企业", value: "1" },
      ], //变更类型选择

      pagingObj: {
        currentPage: 1, //当前页

        pageSize: 10, // 一页显示多少个

        totalDevice: 0, //用户总数
      }, // 分页数据

      VisibleBuyBean: false, //购买发票豆

      VisibleUp: false, //上传开具发票

      dialogIssue: false, //开具发票

      reissueId: "", //重开发票ID

      DeRe: 0, //0详情1申请代开发票退款

      VisibleDeRe: false, //0详情1申请代开发票退款

      VisibleDueDate: false, //查看即将到期发票豆

      VisibleHesitation: false, //立即办理弹窗

      VisibleEvaluation: false, //服务评价弹窗
      evaluatedName: "", // 被评价人

      orderNumber: "", //订单号

      handleTypeName: "", //服务类型

      businessTypeName: "", //服务类别

      InvoiceBean: "0", //发票豆

      Expired: {}, //即将过期发票豆

      seller: {}, //销售方信息

      options: [],

      row: {}, // 详情

      reissueRow: null, //重开发票的行数据

      VisibleWarning: false, //温馨提示弹窗

      pendingAction: null, //待执行的操作
    };
  },

  watch: {},

  components: {
    paging,

    BuyBean, // 购买发票豆

    UpInvoice, //上传开具发票

    OpenInvoice, //开具发票

    DeOfRe, //详情/申请退款弹窗

    DueDate, //即将到期发票豆详情

    Hesitation, //立即办理弹窗

    EvaluationDialog, //服务评价弹框
  },

  created() {
    this.sellerInvoiceInfo(); //获取销售方发票信息

    this.countCompanyInvoiceBeans(); //统计企业用户全部发票豆

    this.countCompanyExpiringSoonInvoiceBeans(); //即将过期发票豆

    this.companyInvoice(); // 查询代开发票分页列表

    this.companySelectCustomers(); ////查询客户列表(客户下拉选择)
  },

  mounted() {
    // 每次进入页面都会重新监听

    // 购买/续费代理记账在index页面，购买后本页面不知道没有刷新客户列表接口，

    // 在办理服务时就会出现已经购买代理记账知道本公司的纳税类型但表单中仍需选择

    // 调用此方法购买代理记账以后 本页面监听到直接刷新客户列表接口

    this.$bus.$on("refresh-company-customers", this.handleRefresh);
  },

  beforeDestroy() {
    this.$bus.$off("refresh-company-customers", this.handleRefresh);
  },

  methods: {
    handleRefresh() {
      this.companySelectCustomers();
    },

    //付款成功

    handleSuccess() {
      this.VisibleBuyBean = false;

      this.countCompanyInvoiceBeans(); //统计企业用户全部发票豆

      this.companyInvoice(); // 查询代开发票分页列表
    },

    //查询客户列表(客户下拉选择)

    companySelectCustomers() {
      if (!this.$checkActionIpu()) return;

      API.companySelectCustomers().then((res) => {
        var arr = res.data.customers;

        // arr.unshift(res.data.self);

        this.options = arr;
      });
    },

    //重置

    handelReset() {
      this.pagingObj.currentPage = 1;

      this.screenData = {
        value: null, // 时间

        input: "", //开票主体

        code: "", //统一社会信用代码

        headType: "", //性质

        orderNumber: "",
      };

      this.companyInvoice(); // 查询代开发票分页列表
    },

    //搜索

    handelSearch() {
      this.pagingObj.currentPage = 1;

      this.companyInvoice(); // 查询代开发票分页列表
    },

    // 查询代开发票分页列表

    companyInvoice() {
      // 处理时间（叉号清空后为 null，需先判断再取下标）

      var time;
      var timeEnd;
      var range = this.screenData.value;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
      }

      var data = {
        data: {
          customerName: this.screenData.input, //购买方

          creditCode: this.screenData.code, //代码

          startTime: time,

          endTime: timeEnd,

          headType: this.screenData.headType, //性质

          orderNumber: this.screenData.orderNumber, //订单id
        },
      };

      API.companyInvoice(
        data,

        this.pagingObj.currentPage,

        this.pagingObj.pageSize
      ).then((res) => {
        this.tableData = res.data.list;

        this.pagingObj.totalDevice = res.data.total;
      });
    },

    //获取销售方发票信息

    sellerInvoiceInfo() {
      if (!this.$checkActionIpu()) return;

      var data = {
        data: {},
      };

      API.sellerInvoiceInfo(data).then((res) => {
        this.seller = res.data;
      });
    },

    //统计企业用户全部发票豆

    countCompanyInvoiceBeans() {
      API.countCompanyInvoiceBeans().then((res) => {
        if (res.code == 0) {
          this.InvoiceBean = res.data;
        }
      });
    },

    // 即将过期发票豆

    countCompanyExpiringSoonInvoiceBeans() {
      API.countCompanyExpiringSoonInvoiceBeans().then((res) => {
        if (res.code == 0) {
          this.Expired = res.data;
        }
      });
    },

    // 立即办理确定

    handleUnHesitation() {
      this.$tool

        .InvoiceProcess(
          "/global/proxy/invoiceProcess",

          this.row.orderNumber
        )

        .then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");

            this.companyInvoice();
          }
        });

      this.VisibleHesitation = false;
    },

    //立即办理

    handelHesitation(row) {
      if (!this.$checkAction()) return;

      this.row = row;

      this.VisibleHesitation = true;
    },

    // 点击即将到期发票都详情

    handelDueDate() {
      if (!this.$checkAction()) return;

      this.VisibleDueDate = true;
    },

    // 服务评价

    handelEvaluation(row) {
      if (!this.$checkAction()) return;

      this.orderNumber = row.orderNumber;

      this.handleTypeName = "代理记账";

      this.businessTypeName = "代开发票";

      this.evaluatedName = row.customerName || "";
      this.VisibleEvaluation = true;
    },

    // 关闭服务评价弹框

    handleCloseEvaluation() {
      this.VisibleEvaluation = false;
    },

    // 服务评价成功

    handleEvaluationSuccess() {
      this.companyInvoice();
    },

    // 列表操作 - 重新开票

    handelResubmit(index, row) {
      if (!this.$checkAction()) return;

      if (this.InvoiceBean > 0) {
        this.reissueId = ""; // 先清空，确保值变化触发 watch
        this.reissueRow = null;
        this.pendingAction = { type: "resubmit", index, row };
        this.VisibleWarning = true;
      } else {
        this.$tool.PromptBox("warning", "发票豆数量不足，请先购买发票豆!");
      }
    },

    //点击开具发票

    handelOpen() {
      if (!this.$checkAction()) return;

      if (this.InvoiceBean > 0) {
        this.reissueId = ""; // 清空重开发票ID
        this.reissueRow = null; // 清空重开发票行数据
        this.pendingAction = { type: "open" };

        this.VisibleWarning = true;
      } else {
        this.$tool.PromptBox("warning", "发票豆数量不足，请先购买发票豆!");
      }
    },

    //开具发票弹窗确认
    handleVerifyIssue() {
      this.countCompanyInvoiceBeans();
      this.companyInvoice(); // 查询代开发票分页列表
      this.dialogIssue = false;
      this.reissueId = ""; // 清空重开发票ID
      this.reissueRow = null; // 清空重开发票行数据
    },
    //开具发票弹窗关闭
    handleIssue() {
      this.dialogIssue = false;
    },

    // 上传开具发票

    handelUp() {
      if (!this.$checkAction()) return;

      if (this.InvoiceBean > 0) {
        this.pendingAction = { type: "upload" };

        this.VisibleWarning = true;
      } else {
        this.$tool.PromptBox("warning", "发票豆数量不足，请先购买发票豆!");
      }
    },

    // 上传开具发票确认

    handleConfirmUp() {
      this.countCompanyInvoiceBeans();
      this.companyInvoice();
      this.VisibleUp = false;
    },

    // 购买发票豆弹窗确认

    handleUnBuyBean() {
      this.VisibleBuyBean = false;
    },

    // 购买发票豆

    handelBuyBean() {
      if (!this.$checkAction()) return;

      this.VisibleBuyBean = true;
    },

    // 表格-详情 / 申请退豆

    handelDetails(row, num) {
      console.log(row);

      this.row = row;

      this.DeRe = num;

      if (num == 1) {
        if (!this.$checkAction()) return;

        this.VisibleDeRe = true;
      } else {
        this.VisibleDeRe = true;
      }
    },

    // 表格 - 详情/退豆弹窗确认

    handleConfirmDeRe(textarea) {
      this.$tool

        .Refund(
          "/global/proxy/invoiceRequestRefund",

          this.row.orderNumber,

          textarea
        )

        .then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");

            this.companyInvoice();
          }
        });

      this.VisibleDeRe = false;
    },

    // 分页

    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;

      this.companyInvoice(); // 查询代开发票分页列表
    },


    // 状态色：处理中蓝 / 完成绿 / 退款橙 / 作废红
    getStatusColor(row) {
      return this.$tool.getProxyStatusColor(row);
    },

    // 投诉

    handelComplaint() {
      this.$router.push({ path: "/Firm/firmComplain" });
    },

    //表格分页序号

    NIndex(index) {
      // 当前页数 - 1 * 每页数据条数 + 1

      const page = this.pagingObj.currentPage; // 当前页码

      const pagesize = this.pagingObj.pageSize; // 每页条数

      return index + 1 + (page - 1) * pagesize;
    },

    // 温情提示弹窗 - 关闭

    handleWarningClose() {
      this.VisibleWarning = false;

      this.pendingAction = null;
    },

    // 温情提示弹窗 - 确认

    handleWarningConfirm() {
      this.VisibleWarning = false;

      if (this.pendingAction) {
        switch (this.pendingAction.type) {
          case "resubmit":
            this.reissueId = this.pendingAction.row.id;

            this.reissueRow = this.pendingAction.row;

            this.dialogIssue = true;

            break;

          case "upload":
            this.VisibleUp = true;

            break;

          case "open":
            this.dialogIssue = true;

            break;
        }

        this.pendingAction = null;
      }
    },
  },
};
</script>



<style scoped lang="less">
/* 主内容区滚动条样式 */

::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  height: 8px; /* 主内容区水平滚动条高度 */
}

::v-deep .el-table__fixed-right {
  height: 100% !important; /* 覆盖默认高度计算 */
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c0c0c0; /* 灰色滑块，比轨道深一些 */

  border-radius: 4px; /* 可选：滑块圆角 */
}

::v-deep .el-table__body-wrapper {
  scrollbar-width: thin; /* Firefox 中"thin"约 8px 粗细 */

  scrollbar-color: #c0c0c0 #f5f5f5; /* 滑块色 + 轨道色 */
}

.Invoice-body {
  width: 100%;

  height: 100%;

  font-family: PingFangSC-Medium;

  font-weight: 400;

  // 筛选 + 发票豆并排

  .screen-with-bean {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    margin-top: 10px;
  }

  // 筛选

  .screen {
    flex: 1;
    min-width: 0;
    margin-top: 0;
    margin-bottom: 0;
    position: relative;
.size-search-wide {
      width: 220px;
    }
  }

  // 发票豆（搜索右侧）

  .bean-panel {
    flex-shrink: 0;
    min-width: 260px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-top: 2px;

    .bean-row {
      display: flex;
      align-items: center;

      .Remaining {
        font-size: 16px;
        color: #333333;
        white-space: nowrap;

        .bean-num {
          color: #409eff;
        }
      }

      .Buy {
        width: 72px;
        height: 32px;
        margin-left: 12px;
        background: #409eff !important;
        border-color: #409eff !important;
        border-radius: 5px;
        font-size: 14px;
        color: #ffffff !important;
        cursor: pointer;
        font-family: inherit;
        padding: 0 !important;
        line-height: 1 !important;
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
      }
    }

    .bean-note {
      margin-top: 8px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 12px;
      color: #999999;
      line-height: 18px;

      .bean-detail {
        margin-left: 10px;
        color: #409eff;
        text-decoration: underline;
        cursor: pointer;
        white-space: nowrap;
      }
    }
  }

  // 表上方的操作项

  .table-top-Controls {
    width: 100%;
    height: 35px;
    display: flex;
    align-items: center;

    .action-btn {
      width: 100px;
      height: 35px;
      background: #409eff !important;
      border-color: #409eff !important;
      border-radius: 5px;
      font-size: 14px;
      color: #ffffff !important;
      cursor: pointer;
      font-family: inherit;
      padding: 0 !important;
      line-height: 1 !important;
      display: inline-flex !important;
      align-items: center;
      justify-content: center;
    }

    .RemainingLocation {
      display: flex;
      flex: 1;
      justify-content: flex-end;
      align-items: center;

      .action-btn {
        margin-left: 20px;
      }
    }
  }

  //   表格

  .Table {
    min-height: 450px;

    margin-top: 30px;

    // border: 1px solid gold;

    .span-Operation {
      color: #409eff ;

      margin-left: 10px;

      cursor: pointer;
    }

    .span-Operation:nth-child(1) {
      margin-left: 0px;
    }
  }

  // 分页

  .paging-box {
    width: 100%;

    height: 22px;

    margin-top: 30px;

    display: flex;

    justify-content: flex-end;

    .paging {
      width: 90%;

      height: 100%;

      display: flex;

      justify-content: flex-end;
    }
  }
}
</style>



<style lang="less" scoped>
.warning-content {
  color: #666666 ;
  font-size: 14px;
  line-height: 24px;

  .warning-title {
    margin-bottom: 20px;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: #2B2B2B;
  }

  .warning-desc {
    margin-bottom: 12px;
    text-align: left;
  }

  .warning-list {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      position: relative;
      padding-left: 16px;
      margin-bottom: 8px;
      text-align: left;
      list-style: none;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 9px;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #333333;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .em {
    font-weight: 600;
    color: #333;
  }
}

.warning-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.warning-confirm-btn {
  width: auto !important;
  min-width: 88px !important;
  padding: 0 16px !important;
}
</style>

<style lang="less">
/* 温馨提示弹窗内按钮需盖过全局 .el-button 宽度 */
.zj-dialog-model {
  .warning-footer {
    .dialog-model-btn-cancel {
      width: 64px !important;
      min-width: 64px !important;
    }
    .warning-confirm-btn {
      width: auto !important;
      min-width: 88px !important;
      padding: 0 16px !important;
      background: #409eff !important;
      border-color: #409eff !important;
      color: #fff !important;
    }
  }
}
</style>

